import { CSSProperties, PropsWithChildren, useState } from 'react'
import './TextCell.scss'

interface TextCellProps extends PropsWithChildren {
  disabled?: boolean
  style?: CSSProperties
  onClick?: () => void
}

export function TextCell(props: TextCellProps) {
  const text = props.children as string
  const showTooltip = text.length > 30
  const [hovered, setHovered] = useState(false)
  return (
    <div className="textCell">
      <div
        style={props.style}
        onMouseOver={() => {
          if (showTooltip) setHovered(true)
        }}
        onMouseLeave={() => {
          if (showTooltip) setHovered(false)
        }}
        className={`grid-text-cell ${props.disabled ? 'disabled' : ''}`}
        onClick={props.onClick}
      >
        {props.children}
      </div>
      {showTooltip && hovered && (
        <span
          className="tooltip"
          onMouseOver={() => {
            if (showTooltip) setHovered(true)
          }}
          onMouseLeave={() => {
            if (showTooltip) setHovered(false)
          }}
        >
          {props.children}
        </span>
      )}
    </div>
  )
}
